import {Injectable} from '@angular/core';
import { Platform } from '@ionic/angular';
import {Observable, of} from 'rxjs';

import * as moment from 'moment';

import {environment} from 'environment';
import { getMessaging, getToken, Messaging, onMessage } from 'firebase/messaging';

import {
  ActionPerformed,
  DeliveredNotifications,
  PushNotifications,
  PushNotificationSchema, Token} from '@capacitor/push-notifications';

@Injectable()
export class FCMService {

  private token: string = '';

  private tokenRefreshCallback: (token: string) => void = null;
  private notificationCallback: (notification: PushNotificationSchema) => void = null;

  private actionPerformed: moment.Moment = null;
  private storedNotification: ActionPerformed = null;

  constructor(private platform: Platform) {
    if (this.platform.is('capacitor')) {

      // Request permission to use push notifications
      // iOS will prompt user and return if they granted permission or not
      // Android will just grant without prompting
      PushNotifications.requestPermissions().then( (result) => {
        if (result.receive) {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });

      PushNotifications.addListener('registration',
        (token: Token) => {
          // alert('Push registration success, token: ' + token.value);
          this.token = token.value;
          console.log('### Push registration success, token: ' + token.value);
          if (this.tokenRefreshCallback !== null) {
            this.tokenRefreshCallback(token.value);
          }
        },
      );

      PushNotifications.addListener('registrationError',
        (error: any) => {
          alert('Error on registration: ' + JSON.stringify(error));
        },
      );

      PushNotifications.addListener('pushNotificationReceived',
        (notification: PushNotificationSchema) => {
          console.log('### Push received: ' + JSON.stringify(notification));
        },
      );

      PushNotifications.addListener('pushNotificationActionPerformed',
        (notification: ActionPerformed) => {
          console.log('### Push action performed: ' + JSON.stringify(notification));
          this.actionPerformed = moment();
          this.storedNotification = notification;
          if (this.notificationCallback !== null) {
            this.notificationCallback(notification.notification);
          }
        },
      );
    } else {
      this.requestPermissionWeb();
      this.listenWeb();
      return;
    }
  }

  public setTokenRefreshCallback(callback: (token: string) => void): void {
    this.tokenRefreshCallback = callback;
  }

  public setNotificationCallback(callback: (x: PushNotificationSchema) => void): void {
    this.notificationCallback = callback;
  }

  public getDeviceToken(): Observable<string> {
    return of(this.token);
  }

  private requestPermissionWeb() {
    const messaging = getMessaging();
    getToken(messaging, 
     //{ vapidKey: environment.firebase.vapidKey}
     ).then(
       (currentToken) => {
         if (currentToken) {
           console.log('### WebPush registration success, token: ' + currentToken);
           if (this.tokenRefreshCallback !== null) {
            this.tokenRefreshCallback(currentToken);
          }
         } else {
           console.log('No registration token available. Request permission to generate one.');
         }
     }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
  }
  private listenWeb(): void {
    const messaging: Messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('### WebPush action performed: ' + JSON.stringify(payload));
      if (this.notificationCallback !== null) {
        const notification: PushNotificationSchema = {
          id: '',
          data: payload.data,
        };
        this.notificationCallback(notification);
      }
    });
  }

  public recentlyActionPerformed(reset: boolean): boolean {
    const result: boolean = this.actionPerformed != null && moment().diff(this.actionPerformed, 'seconds') < 10;
    if (reset) {
      this.actionPerformed = null;
    }
    return result;
  }

  public getStoredNotification(reset: boolean): ActionPerformed {
    const notification = this.storedNotification;
    if (reset) {
      this.storedNotification = null;
    }
    return notification;
  }


}
